<h1 mat-dialog-title>{{ 'properties.list.exportFile' | translate }}</h1>

<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <p class="text-muted">{{ 'properties.documentsV3.dossierDialog.subtitle' | translate }}</p>

      <div class="text-center my-3" *ngIf="state === 'loading'">
        <mat-spinner diameter="30" class="d-inline-block"></mat-spinner>
      </div>

      <div class="alert alert-warning" *ngIf="state === 'failed' && failure">
        {{ failure.key | translate: failure.params }}
      </div>

      <ng-container *ngIf="state === 'loaded'">
        <!-- One row per part: each one is asked for on its own, and one at a time, since a part holds
             about 500 MB of files and arrives whole in the memory of the browser (NEW-M17). -->
        <div class="download-row" *ngFor="let part of parts">
          <button mat-stroked-button color="primary" class="mr-2 download-btn"
            [disabled]="downloadingPart !== null" [attr.aria-busy]="downloadingPart === part.part"
            (click)="onDownload(part)">
            <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
            {{ 'properties.documentsV3.dossierDialog.download' | translate }}
          </button>
          <span class="download-name">{{ part.fileName }}</span>
          <span class="text-muted ml-2">
            {{ part.filesMessage.key | translate: part.filesMessage.params }}<ng-container *ngIf="part.sizeText"> · {{ part.sizeText }}</ng-container>
          </span>
          <mat-spinner class="ml-2 download-spinner" diameter="18" *ngIf="downloadingPart === part.part"></mat-spinner>
        </div>

        <div class="alert alert-warning" *ngIf="!parts.length">
          {{ 'properties.documentsV3.dossierDialog.empty' | translate }}
        </div>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>

<div class="row custom-dialog-footer">
  <!-- With «Riprova» the two buttons sit at opposite ends; without it «Chiudi» stays on the left -->
  <div class="col-12"
    [ngClass]="state === 'failed' ? 'd-flex justify-content-between align-items-center' : 'text-left'">
    <a mat-button (click)="onClose()" mat-raised-button mat-default class="ml-3">
      {{ 'common.cta.close' | translate }}
    </a>
    <button *ngIf="state === 'failed'" type="button" mat-raised-button color="primary" class="mr-3"
      (click)="onRetry()">
      {{ 'properties.documentsV3.retry' | translate }}
    </button>
  </div>
</div>
